export default function round(n, d = 4) {
  return Math.round(n * 10 ** d) / 10 ** d;
}
